import React from 'react';
import PropTypes from 'prop-types';
import { SvgStar } from '../../svg';
import { RatingWrapper } from './styles';

function Rating(props) {
  const { value, max = 5 } = props;

  return (
    <RatingWrapper>
      {[...Array(max)].map((_, i) => (
        <SvgStar key={i} fill={i + 1 <= value} />
      ))}
    </RatingWrapper>
  );
}

Rating.propTypes = {
  value: PropTypes.number,
  max: PropTypes.number,
};

export default Rating;
